"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddDomain = void 0;
const react_1 = __importDefault(require("react"));
const utils_1 = require("../../../../common/utils");
const VerticalStack_1 = __importDefault(require("@mdigital/components/dist/components/VerticalStack"));
const alchemy_ui_1 = require("@m/alchemy-ui");
const react_final_form_1 = require("react-final-form");
const helpers_1 = require("../helpers");
const TextPathPrefix = 'app.pages.administration.domainsList';
const AddDomainTitle = `${TextPathPrefix}.addDomain`;
const Add = `${TextPathPrefix}.add`;
const Cancel = `${TextPathPrefix}.cancel`;
const Subtitle = `${TextPathPrefix}.addDomainSubtitle`;
const Label = `${TextPathPrefix}.domainURL`;
const DomainError = `${TextPathPrefix}.domainError`;
const Placeholder = `${TextPathPrefix}.placeholder`;
const DomainDuplicationError = `${TextPathPrefix}.domainDuplicationError`;
const AddedNotification = `${TextPathPrefix}.domainAddedNotification`;
const triggerAlert = () => {
    (0, utils_1.getNgService)(($rootScope) => $rootScope.addAlert('success', (0, utils_1.getSingleText)(AddedNotification)), true);
};
const AddDomain = (props) => {
    const body = (react_1.default.createElement("div", null,
        react_1.default.createElement(VerticalStack_1.default, { gap: 'small' },
            react_1.default.createElement(react_final_form_1.Field, { name: 'domainName', validate: (value) => (0, helpers_1.validation)(value, props.domains, DomainError, DomainDuplicationError), render: ({ input, meta }) => (react_1.default.createElement(alchemy_ui_1.Field, { isFullWidth: true, required: true, label: (0, utils_1.getSingleText)(Label), input: react_1.default.createElement(alchemy_ui_1.Input, Object.assign({ defaultValue: meta.initial, placeholder: (0, utils_1.getSingleText)(Placeholder) }, input)), status: meta.error && meta.touched ? { level: 'error', message: meta.error } : undefined })) }))));
    const onSubmit = (value) => __awaiter(void 0, void 0, void 0, function* () {
        const date = Date.now();
        props.onSubmit({ 'domainName': value.domainName.trim(), 'lastModifiedTimestamp': date });
        triggerAlert();
    });
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(react_final_form_1.Form, { onSubmit: onSubmit, render: ({ handleSubmit }) => props.render({
                size: 'small',
                close: {
                    title: (0, utils_1.getSingleText)(Cancel),
                },
                submit: {
                    callback: (context) => {
                        var _a;
                        (_a = handleSubmit()) === null || _a === void 0 ? void 0 : _a.then(() => context.close());
                    },
                    title: (0, utils_1.getSingleText)(Add),
                    shouldAutoClose: false,
                },
                body: body,
                title: (0, utils_1.getSingleText)(AddDomainTitle),
                description: react_1.default.createElement(react_1.default.Fragment, null, (0, utils_1.getSingleText)(Subtitle)),
            }) })));
};
exports.AddDomain = AddDomain;
